module.exports = __webpack_public_path__ + "static/media/国元证券@2x.d100283f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/国元证券@2x.png
// module id = 1586
// module chunks = 0